import styled from '@emotion/styled'
import { media } from '@dfds-ui/theme'
import { css } from '@emotion/react'
import Skeleton from './Skeleton'

const GridItem = styled.div`
  height: 58px;
  width: 100%;
  border: none;
  border-color: #e2e8f0;

  @media (min-width: 1024px) {
    &:not(:last-child) {
      border-right: none;
    }
  }

  &.col-span-12 {
    grid-column: span 12;
  }

  &.md-col-span-6 {
    @media (min-width: 768px) {
      grid-column: span 6;
    }
  }

  &.lg-col-auto {
    @media (min-width: 1024px) {
      grid-column: auto;
    }
  }

  &.lg-col-span-2 {
    @media (min-width: 1024px) {
      grid-column: span 2;
    }
  }

  &.lg-col-span-1 {
    @media (min-width: 1024px) {
      grid-column: span 1;
    }
  }
`

const TravelSearchSkeleton = () => {
  return (
    <div
      css={css`
        position: relative;
        padding: 16px;
        display: flex;
        flex-direction: column;
        gap: 8px;

        ${media.greaterThan('l')`
          padding: 8px;
        `}
      `}
    >
      <div
        css={css`
          display: flex;
          flex-direction: row;
          align-items: center;
          height: 45px;
        `}
      >
        <Skeleton
          css={css`
            height: 100%;
            width: 175px;
            border-radius: 4px;
          `}
        />
      </div>
      <div
        css={css`
          display: grid;
          grid-template-columns: repeat(12, 1fr);
          gap: 8px;
          background-color: transparent;

          ${media.greaterThan('l')`
            grid-template-columns: repeat(6, 1fr);
            grid-template-rows: 1fr;
            gap: 4px;
          `}
        `}
      >
        <GridItem className="col-span-12 md-col-span-6 lg-col-auto">
          <Skeleton
            css={css`
              height: 100%;
              width: 100%;
            `}
          />
        </GridItem>
        <GridItem className="col-span-12 md-col-span-6 lg-col-auto">
          <Skeleton
            css={css`
              height: 100%;
              width: 100%;
            `}
          />
        </GridItem>
        <GridItem className="col-span-12 md-col-span-6 lg-col-auto">
          <Skeleton
            css={css`
              height: 100%;
              width: 100%;
            `}
          />
        </GridItem>
        <GridItem className="col-span-12 md-col-span-6 lg-col-span-2">
          <Skeleton
            css={css`
              height: 100%;
              width: 100%;
            `}
          />
        </GridItem>
        <GridItem
          css={css`
            height: 54px;
            width: 100%;

            ${media.greaterThan('m')`
              height: 58px;
            `}
          `}
          className="col-span-12 lg-col-span-1"
        >
          <Skeleton
            css={css`
              height: 54px;
              width: 100%;

              ${media.greaterThan('m')`
                height: 58px;
              `}
            `}
          />
        </GridItem>
      </div>
    </div>
  )
}

export default TravelSearchSkeleton
